import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConsultaCepResponse } from 'src/app/@shared/models/consulta-cep.model';
import { AlterarEntidadeRequest, AlterarEntidadeResponse } from 'src/app/@shared/models/manifesto-embarque-painel-cte.model';
import { ConsultaCepService } from 'src/app/services/consulta-cep/consulta-cep.service';
import { ManifestoEmbarquePainelCteService } from 'src/app/services/manifesto-embarque-painel-cte/manifesto-embarque-painel-cte.service';
import { ManutencaoClienteService } from 'src/app/services/manutencao-clientes/manutencao-cliente.service';

@Component({
  selector: 'app-painel-cte-modal-entidade',
  templateUrl: './painel-cte-modal-entidade.component.html',
  styleUrls: ['./painel-cte-modal-entidade.component.scss']
})
export class PainelCteModalEntidadeComponent implements OnInit {
  isLoading: boolean;

  tipoEntidade: string;
  entidade: AlterarEntidadeRequest;

  listaUF = [];
  cnpjInvalido: boolean;

  formEntidade: FormGroup = new FormGroup({
    tipoPessoa: new FormControl('', Validators.required),
    cgc: new FormControl('', [Validators.required, Validators.maxLength(18)]),
    razaoSocial: new FormControl('', [Validators.required, Validators.maxLength(100)]),
    inscricaoEstadual: new FormControl('', [Validators.required, Validators.maxLength(14)]),
    endereco: new FormGroup({
      cep: new FormControl('', [Validators.required, Validators.maxLength(8)]),
      ibge: new FormControl('', [Validators.required, Validators.maxLength(5)]),
      uf: new FormControl('', Validators.required),
      municipio: new FormControl('', [Validators.required, Validators.maxLength(100)]),
      bairro: new FormControl('', [Validators.required, Validators.maxLength(40)]),
      logradouro: new FormControl('', [Validators.required, Validators.maxLength(40)]),
    })
  });
  get tipoPessoa () { return this.formEntidade.get('tipoPessoa').value; };
  get cgc () { return this.formEntidade.get('cgc').value; };
  get razaoSocial () { return this.formEntidade.get('razaoSocial').value; };
  get inscricaoEstadual () { return this.formEntidade.get('inscricaoEstadual').value; };
  get cep () { return this.formEntidade.get(['endereco', 'cep']).value; };
  get ibge () { return this.formEntidade.get(['endereco', 'ibge']).value; };
  get uf () { return this.formEntidade.get(['endereco', 'uf']).value; };
  get municipio () { return this.formEntidade.get(['endereco', 'municipio']).value; };
  get bairro () { return this.formEntidade.get(['endereco', 'bairro']).value; };
  get logradouro () { return this.formEntidade.get(['endereco', 'logradouro']).value; };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PainelCteModalEntidadeComponent>,
    public snackBar: MatSnackBar,
    private manutencaoCliente: ManutencaoClienteService,
    private consultaCepService: ConsultaCepService,
    private painelCteService: ManifestoEmbarquePainelCteService
  ) {
    this.entidade = data.objEntidade
    this.tipoEntidade = data.objEntidade.tipoEntidade
  }

  ngOnInit() {
    this.carregarDados();
  }
  
  async carregarDados() {
    this.isLoading = true;

    await Promise.all([
      this.ListarUf(),
      this.caregarEntidade(),
      this.isLoading = false
    ])
  }

  async ListarUf() {
    return this.manutencaoCliente.listarUF().toPromise().then(
      (response: any) => {
        this.listaUF = response
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Erro ao carregar UFs, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  };

  public consultaCNPJ() {
    if (this.cgc != null && this.cgc != '') {
      this.manutencaoCliente.consultaCNPJ(this.cgc).subscribe(
        (response: any) => {
          this.cnpjInvalido = response;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar('Erro ao consultar CGC, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        });
    }
  }

  editarEntidade() {
    this.isLoading = true;

    const obj: AlterarEntidadeRequest = {
      filial: this.entidade.filial,
      numCTe: this.entidade.numCTe,
      tipoEntidade: this.tipoEntidade,
      cgc: this.cgc,
      razaoSocial: this.razaoSocial.toUpperCase(),
      insEstadual: this.inscricaoEstadual,
      uf: this.uf,
      municipio: this.municipio.toUpperCase(),
      ibge: this.ibge,
      endereco: this.logradouro.toUpperCase(),
      bairro: this.bairro.toUpperCase(),
      cep: this.cep,
      tipoPessoa: this.tipoPessoa,
    }

    this.painelCteService.alterarEntidade(obj).subscribe(
      (response: AlterarEntidadeResponse) => {
        this.openSnackBar(`Alteração realizada com sucesso!`, 'OK', 5000, 'success-snackbar');
        this.dialogRef.close('sucesso');
      },
      (err: HttpErrorResponse) => {
        console.error(err),
        this.openSnackBar(`Erro ao editar entidade ${this.tipoEntidade}! Protocolo: ` + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      },
      () => this.isLoading = false
    )
  }

  consultarCep() {
    if (this.cep.length !== 8) {
      return this.openSnackBar('O CEP deve ter 8 digitos!', 'OK', 5000, 'danger-snackbar');
    }

    this.formEntidade.get(['endereco']).disable();

    this.consultaCepService.consultaCEP(this.cep).subscribe(
      (response: ConsultaCepResponse) => {
        if (response.erro) {
          this.formEntidade.get(['endereco']).reset();
          this.formEntidade.get(['endereco']).updateValueAndValidity();
          return this.openSnackBar('CEP inválido', 'OK', 5000, 'danger-snackbar');
        } else {
          const { bairro, cep, ibge, localidade, logradouro, uf } = response;

          this.formEntidade.get(['endereco', 'bairro']).setValue(bairro);
          this.formEntidade.get(['endereco', 'cep']).setValue(cep.replace('-', ''));
          this.formEntidade.get(['endereco', 'ibge']).setValue(ibge.slice(2));
          this.formEntidade.get(['endereco', 'municipio']).setValue(localidade);
          this.formEntidade.get(['endereco', 'logradouro']).setValue(logradouro);
          this.formEntidade.get(['endereco', 'logradouro']).markAsTouched();
          this.formEntidade.get(['endereco', 'uf']).setValue(uf);
          this.formEntidade.updateValueAndValidity();
        }
      },
      (error: HttpErrorResponse) => {
        console.error(error);
        this.openSnackBar('Erro ao consultar CEP, entre em contato com o suporte : ' + error.error.Protocolo, 'OK', 10000, 'danger-snackbar');
      })
      .add(() => this.formEntidade.get(['endereco']).enable()
    )
  }

  caregarEntidade() {
    this.formEntidade.get('tipoPessoa').setValue(this.entidade.tipoPessoa);
    this.formEntidade.get('cgc').setValue(this.entidade.cgc);
    this.formEntidade.get('razaoSocial').setValue(this.entidade.razaoSocial);
    this.formEntidade.get('inscricaoEstadual').setValue(this.entidade.insEstadual);
    this.formEntidade.get(['endereco', 'cep']).setValue(this.entidade.cep);
    this.formEntidade.get(['endereco', 'ibge']).setValue(this.entidade.ibge);
    this.formEntidade.get(['endereco', 'uf']).setValue(this.entidade.uf);
    this.formEntidade.get(['endereco', 'municipio']).setValue(this.entidade.municipio);
    this.formEntidade.get(['endereco', 'bairro']).setValue(this.entidade.bairro);
    this.formEntidade.get(['endereco', 'logradouro']).setValue(this.entidade.endereco);
    this.formEntidade.updateValueAndValidity();
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
